import RichText from '@components/elements/rich-text/rich-text';
import LayoutSafeArea from '@components/layout/layout-safe-area/layout-safe-area';
import PageTitleBar from '@components/layout/page-title-bar/page-title-bar';
import PizzaManifesto from '@components/pizza-manifesto/pizza-manifesto';
import { v2_fetchCmsBlocksFallback, v2_fetchCmsPage } from '@crocodille/common';
import { AppPage } from '@framework/page';
import { getAboutLayout } from '@layouts/about-layout/about-layout';
import { getApp } from '@utils/app';
import { getServerSideTranslationProps } from '@utils/i18n';
import { GetServerSideProps } from 'next';

export interface PizzaManifestoPageProps {
  readonly fallback: Record<string, unknown>;
  readonly title: string;
  readonly content: string;
}

const PizzaManifestoPage: AppPage<PizzaManifestoPageProps> = (props) => {
  return (
    <>
      <LayoutSafeArea>
        <PageTitleBar title={props.title} />
        <PizzaManifesto />
        <RichText html={props.content} />
      </LayoutSafeArea>
    </>
  );
};

PizzaManifestoPage.getLayout = (page, pageProps) => {
  return getAboutLayout(page, pageProps.fallback);
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const app = getApp(ctx);

  const [translationProps, cmsBlocksFallback, pizzaPage] = await Promise.all([
    getServerSideTranslationProps(app, ['common']),
    v2_fetchCmsBlocksFallback(app),
    v2_fetchCmsPage(app, 'pizza'),
  ]);

  if (!pizzaPage) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...translationProps,
      fallback: { ...cmsBlocksFallback },
      title: pizzaPage.title,
      content: pizzaPage.content,
    },
  };
};

export default PizzaManifestoPage;
